import { type SxProps, type Theme } from '@mui/material'

const CARD_WIDTH = '260px'

export const styles = {
  page: {
    backgroundColor: 'var(--grey-100)',
    p: { xs: '16px', md: '24px' },
    borderRadius: '12px'
  } satisfies SxProps<Theme>,
  intro: {
    mb: '20px'
  } satisfies SxProps<Theme>,
  isdHeading: {
    mb: '12px'
  } satisfies SxProps<Theme>,
  cardRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'stretch'
  } satisfies SxProps<Theme>,
  card: {
    width: CARD_WIDTH,
    border: '1px solid var(--blue-300)',
    borderRadius: '8px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  } satisfies SxProps<Theme>,
  cardHeader: {
    backgroundColor: 'var(--blue-500)',
    color: 'var(--white)',
    px: '14px',
    py: '10px'
  } satisfies SxProps<Theme>,
  cardBody: {
    backgroundColor: 'var(--blue-50)',
    p: '14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    flexGrow: 1
  } satisfies SxProps<Theme>,
  statusIcon: (complete: boolean) => ({
    color: complete ? 'var(--green-700)' : 'var(--grey-500)',
    fontSize: '20px',
    mt: '2px'
  } satisfies SxProps<Theme>),
  remind: {
    mt: 'auto',
    pt: '4px'
  } satisfies SxProps<Theme>
}
